import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardContent from "../atoms/DashboardContent";
import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { handleChange, handleSubmit } from "../../atoms/Upsert";
import Input from "../../atoms/Input";
import Select from "../../atoms/Select";
import Button from "../../atoms/Button";
import ButtonCancel from "../../atoms/ButtonCancel";
import ButtonSave from "../../atoms/ButtonSave";
import * as generalHelper from "../../../helpers/generalHelper";
import { getStatuses } from "../../../store/slice/statusSlice";
import { getDeviceTypes } from "../../../store/slice/deviceTypeSlice";

import {
    getDeviceCategory,
    insertDeviceCategory,
    updateDeviceCategory,
    deleteDeviceCategory,
} from "../../../store/slice/deviceCategorySlice";
import routes from "../constants/routes";

export default function (props) {
    const dispatch = useDispatch();
    const [values, setValues] = useState({});
    const statuses = useSelector((state) => state.status.rows);
    const deviceTypes = useSelector((state) => state.deviceType.rows);
    const [redirect, setRedirect] = useState(false);
    const { id } = useParams();

    React.useEffect(() => {
        dispatch(getStatuses({ type: "Default" }));
        dispatch(getDeviceTypes({}));
        if (id) {
            dispatch(getDeviceCategory({ id: id })).then((response) => {
                setValues(response.payload);
            });
        }
    }, []);

    function Content(props) {
        const handleDelete = () => {
            dispatch(deleteDeviceCategory({ id })).then((response) => {
                setRedirect(`${routes.index}${routes.deviceCategory.root}`);
            });
        };
        return (
            <div className="card card-primary">
                <form
                    type="post"
                    onSubmit={(event) => {
                        handleSubmit(event, {
                            id: id,
                            values: values,
                            functions: {
                                insert: insertDeviceCategory,
                                update: updateDeviceCategory,
                            },
                            callback: {
                                function: setRedirect,
                                params: `${routes.index}${routes.deviceCategory.root}`,
                            },
                            dispatch: dispatch,
                        });
                    }}
                >
                    <div className="card-body row">
                        <div className="col-sm-6 col-md-4">
                            <Input
                                label="Name"
                                name="name"
                                value={values.name}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Type"
                                name="device_type_id"
                                options={deviceTypes}
                                value={values.device_type_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <Select
                                label="Status"
                                name="status_id"
                                options={statuses}
                                value={values.status_id}
                                handleChange={(event) => {
                                    handleChange(event, values, setValues);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-6">
                                {id > 0 && (
                                    <Button
                                        label="Delete"
                                        className="btn btn-danger"
                                        type="button"
                                        onClick={(event) => {
                                            handleDelete();
                                        }}
                                    />
                                )}
                            </div>
                            <div className="col-sm-6 text-right">
                                <ButtonCancel /> <ButtonSave />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    return (
        <div>
            {redirect && <Navigate to={redirect} />}
            <DashboardContent
                title={id ? "Edit Device Category" : "Create Device Category"}
                icon="fa fa-list"
                content={Content(props)}
                breadcrumb={[
                    {
                        label: "Devices",
                        to: `${routes.index}${routes.device.root}`,
                    },
                    {
                        label: "Device Categories",
                        to: `${routes.index}${routes.deviceCategory.root}`,
                    },
                    { label: id ? "Edit" : "New" },
                ]}
            />
        </div>
    );
}
